import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { login, logout, langSwap } from "../../actions/piano"
import { useTranslation } from "react-i18next";


function MobileMenu(props) {
  const { t } = useTranslation();

  const [active, setActive] = useState("")
  const [officialUrl, setOfficialUrl] = useState('');
  const [additionalUrl1, setAdditionalUrl1] = useState('');
	const [additionalTitle1, setAdditionalTitle1] = useState('');
	const [additionalUrl2, setAdditionalUrl2] = useState('');
	const [additionalTitle2, setAdditionalTitle2] = useState('');
	const [additionalTitle3, setAdditionalTitle3] = useState('');
	const [additionalUrl3, setAdditionalUrl3] = useState('');

  useEffect(() => {
    if (props.customize) {
      // 公式サイト
      setOfficialUrl(props.customize.official_url);
      // 追加リンク
      setAdditionalInfo();
    }
  },[props.customize])

  useEffect(() => {
		setAdditionalInfo();
	}, [props.language]);

	const setAdditionalInfo = () => {
		//URLをセット
		if (props.customize) {
			setAdditionalUrl1(props.customize.additional_url1);
			setAdditionalUrl2(props.customize.additional_url2);
			setAdditionalUrl3(props.customize.additional_url3);
			if (props.language === 'ja_JP') {
				//日本語のタイトルをセット
				setAdditionalTitle1(props.customize.additional_title1);
				setAdditionalTitle2(props.customize.additional_title2);
				setAdditionalTitle3(props.customize.additional_title3);
			}
			else {
				//英語のタイトルをセット
				setAdditionalTitle1(props.customize.additional_title1_en);
				setAdditionalTitle2(props.customize.additional_title2_en);
				setAdditionalTitle3(props.customize.additional_title3_en);
			}
		}
	}

  const handleActive = () => {
    if (active === "") {
      setActive("active")
    } else if (active === "active") {
      setActive("")
    }
  }
  const handlePurchaseActive = () => {
    if (active === "") {
      setActive("active")
    } else if (active === "active") {
      setActive("")
      window.location.href = "/"
    }
  }

  return (
    <>
      <nav className={`mobile-menu ${active}`}>
        <div className="mobile-menu__line1"/>
        <ul className="mobile-menu-links">
          <li className="mobile-menu-item">
            <Link to="/" onClick={() => handlePurchaseActive()}>{t("menu.programs")}</Link>
          </li>
          <li className="mobile-menu-item">
            <Link to={{pathname: "/", state: { sortType: "purchased" }}} onClick={() => handlePurchaseActive()}>{t("menu.tabMenu.purchased")}</Link>
          </li>
        </ul>
        <div className="mobile-menu__line2"/>
        <ul className="mobile-menu-links tp-cloak">
          {props.loggedIn ? (
            <>
              <li className="mobile-menu-item show-if-logged-in">
                <Link to="/mypage" onClick={() => handleActive()}>{t("menu.mypage")}</Link>
              </li>
              <li className="mobile-menu-item show-if-logged-in">
                <a href="#"className="tp-logout"
                  onClick={() => {
                    handleActive()
                    props.logout()
                  }}
                >
                {t("header.logout")}
                </a>
              </li>
            </>
          ) : (
            <li className="mobile-menu-item show-if-logged-out">
              <a href="#" className="tp-login"
                onClick={() => {
                  handleActive()
                  props.login()
                }}
              >
              {t("header.login")}
              </a>
            </li>
          )}
        </ul>

        <ul className="menu-small-links">
          <li className="menu-small-links__item">
            <Link to="/guide" onClick={() => handleActive()}>{t("menu.guide")}</Link>
          </li>

          <li className="menu-small-links__item">
            <Link to="/confirm" onClick={() => handleActive()}>{t("menu.confirm")}</Link>
          </li>
          <li className="menu-small-links__item">
            <Link to="/faq" onClick={() => handleActive()}>{t("menu.faq")}</Link>
          </li>
          <li className="menu-small-links__item">
            <Link to="/privacy_policy" onClick={() => handleActive()}>{t("menu.privacyPolicy")}</Link>
          </li>
          <li className="menu-small-links__item">
            <Link to="/personal_information" onClick={() => handleActive()}>{t("menu.personalInformation")}</Link>
          </li>
          <li className="menu-small-links__item">
            <Link to="/specified_commercial_transaction_law" onClick={() => handleActive()}>{t("menu.specifiedCommercialTransactionLaw")}</Link>
          </li>
          <li className="menu-small-links__item">
            <Link to="/term_of_service" onClick={() => handleActive()}>{t("menu.termOfService")}</Link>
          </li>
        </ul>
        <ul className="mobile-menu-links">
          {officialUrl && (
            <li className="mobile-menu-item"><a href={officialUrl} target="_blank">{t("menu.officialSite")}</a></li>
          )}
          {additionalUrl1 && additionalTitle1 && (
            <li className="menu-small-links__item"><a href={additionalUrl1} target="_blank" rel="noreferrer" title={additionalTitle1}>{additionalTitle1}</a></li>
          )}
            {additionalUrl2 && additionalTitle2  && (
            <li className="menu-small-links__item"><a href={additionalUrl2} target="_blank" title={additionalTitle2}>{additionalTitle2}</a></li>
          )}
            {additionalUrl3 && additionalTitle3 && (
            <li className="menu-small-links__item"><a href={additionalUrl3} target="_blank" title={additionalTitle3}>{additionalTitle3}</a></li>
          )}
        </ul>

        <ul className="language language--ja language--menu" onClick={() => props.langswap()}>
          <li className={props.language === "ja_JP" ? "language__ja" : "language__en"}><a>{t("header.langJP")}</a></li>
          <li className="language__slash">/</li>
          <li className={props.language === "en_US" ? "language__ja" : "language__en"}><a>{t("header.langEN")}</a></li>
        </ul>
      </nav>
      <div
        className={`mobile-menu-button ${active}`}
        onClick={() => handleActive()}
      >
        <a href="#">
          <span className="mobile-menu-button__line"></span>
          <span className="mobile-menu-button__line"></span>
          <span className="mobile-menu-button__line"></span>
        </a>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    language: state.piano.language,
    loggedIn: state.piano.loggedIn,
    customize: state.customize.customize
  }
}

const mapDispatchToProps = (dispatch) => ({
  login: () => dispatch(login()),
  logout: () => dispatch(logout()),
  langswap: () => dispatch(langSwap())
})

export default connect(mapStateToProps, mapDispatchToProps)(MobileMenu)
